module.exports = __webpack_public_path__ + "media/images/shinagawa-ef4923920521b92438493676d252c9bd.png";